import ToogleTitle from './ToogleTitle';

export default ToogleTitle;
